"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { LuIndent, LuOutdent } from "react-icons/lu";
import { Button } from "@/components/ui";
const INDENT_PX = 40;
function adjustIndent(editor: NonNullable<ReturnType<typeof useEmailComposer>["editor"]>, delta: number) {
  // If inside a list, use list-specific indent/outdent
  if (editor.isActive("bulletList") || editor.isActive("orderedList")) {
    if (delta > 0) {
      return editor.commands.sinkListItem("listItem");
    }
    return editor.commands.liftListItem("listItem");
  }

  // Otherwise, adjust paddingLeft on the current block
  const {
    $from
  } = editor.state.selection;
  for (let d = $from.depth; d >= 0; d--) {
    const node = $from.node(d);
    if (node.type.spec.group === "emailBlock" && "paddingLeft" in node.attrs) {
      const current = parseInt(node.attrs.paddingLeft as string, 10) || 0;
      const next = Math.max(0, current + delta);
      const pos = $from.before(d);
      const {
        tr
      } = editor.state;
      tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        paddingLeft: next > 0 ? `${next}px` : ""
      });
      editor.view.dispatch(tr);
      return true;
    }
  }
  return false;
}
export function IndentButton() {
  const $ = _c(5);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = () => {
      if (!editor) {
        return;
      }
      adjustIndent(editor, INDENT_PX);
      trackEmailComposerAction("indent", "toolbar");
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuIndent size={15} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" onMouseDown={_temp} onClick={t0} tooltip="Indent">{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(e) {
  return e.preventDefault();
}
export function OutdentButton() {
  const $ = _c(5);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = () => {
      if (!editor) {
        return;
      }
      adjustIndent(editor, -INDENT_PX);
      trackEmailComposerAction("outdent", "toolbar");
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LuOutdent size={15} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" onMouseDown={_temp2} onClick={t0} tooltip="Outdent">{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp2(e) {
  return e.preventDefault();
}